import VwHastauyari1DTO from "src/models/HastaUyariModels/VwHastauyari1DTO";
import api from "../core/api";
import VwHastauyari2DTO from "src/models/HastaUyariModels/VwHastauyari2DTO";
import HastaUyariSorguKriterleri from "src/models/HastaUyariModels/HastaUyariSorguKriterleri";

const controllerName = "HastaUyari";

export const HastaUyariListeApi = api.injectEndpoints({
    endpoints: (builder) => ({
        HastaUyari1Ekle: builder.mutation<VwHastauyari1DTO, VwHastauyari1DTO>({
            query: (request) => {
                return {
                    url: `${controllerName}/HastaUyari1Ekle`,
                    method: "POST",
                    body: JSON.stringify(request),
                };
            },
        }),
        HastaUyari1Guncelle: builder.mutation<VwHastauyari1DTO, VwHastauyari1DTO>({
            query: (request) => {
                return {
                    url: `${controllerName}/HastaUyari1Guncelle`,
                    method: "PUT",
                    body: JSON.stringify(request),
                };
            },
        }),
        HastaUyari1Sil: builder.mutation<boolean, VwHastauyari1DTO>({
            query: (request) => {
                return {
                    url: `${controllerName}/HastaUyari1Sil`,
                    method: "DELETE",
                    body: JSON.stringify(request),
                };
            },
        }),
        HastaUyari2Listesi: builder.query<Array<VwHastauyari2DTO>, { hastaUyari1: number }>({
            query: (request) => {
                return {
                    url: `${controllerName}/HastaUyari2Listesi`,
                    method: "GET",
                    params: request,
                }
            },
            providesTags: ["HastaUyari2Listesi"],
        }),
        HastaUyari2Guncelle: builder.mutation<VwHastauyari2DTO, VwHastauyari2DTO>({
            query: (request) => {
                return {
                    url: `${controllerName}/HastaUyari2Guncelle`,
                    method: "PUT",
                    body: JSON.stringify(request),
                };
            },
            invalidatesTags: ["HastaUyari2Listesi"],
        }),
        HastaUyari1Sorgula: builder.query<Array<VwHastauyari1DTO>, HastaUyariSorguKriterleri>({
            query: (request) => {
                return {
                    url: `${controllerName}/HastaUyari1Sorgula`,
                    method: "POST",
                    body: JSON.stringify(request),
                };
            },
            keepUnusedDataFor: 0,
        }),
    }),
});

export const {
    useHastaUyari1EkleMutation,
    useHastaUyari1GuncelleMutation,
    useHastaUyari1SilMutation,
    useHastaUyari2ListesiQuery,
    useHastaUyari2GuncelleMutation,
    useLazyHastaUyari1SorgulaQuery,
} = HastaUyariListeApi;